export const customStyle = {
  control: provided => ({
    ...provided,
    borderRadius: '0px',
    '&:hover': {
      color: '#495057',
      backgroundColor: '#fff',
      borderColor: '#80bdff',
      outline: 0,
      boxShadow: '0 0 0 .2rem rgba(0,123,255,.25)'
    }
  }),
  menu: provided => ({ ...provided, marginTop: '1px' }),
  downchevron: provided => ({ ...provided, borderRadius: '100px' })
};

export const customThemes = theme => ({
  ...theme,
  colors: { ...theme.colors, primary: '#80bdff' }
});

export const customFilter = (option, searchText) =>
  !!option.data.label.toLowerCase().includes(searchText.toLowerCase());

export const firstOption = {
  value: '',
  sortValue: '',
  label: '-- Selecione --'
};

export const handleChangeSelect = (evt, data, setData, setError, setValue) => {
  const { name, value } = evt;
  setData({
    ...data,
    [name]: value
  });
  value ? setError(name) : setError(name, 'required', 'field is required');
  setValue({ [name]: value });
};
